import { render } from "./AcExpansionPanels.vue?vue&type=template&id=04e3d224&scoped=true&ts=true"
import script from "./AcExpansionPanels.vue?vue&type=script&lang=ts"
export * from "./AcExpansionPanels.vue?vue&type=script&lang=ts"

import "./AcExpansionPanels.vue?vue&type=style&index=0&id=04e3d224&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e3d224"]])

export default __exports__